import { Injectable } from '@angular/core';
import { Observable, map } from 'rxjs';
import { ServiceDecorator } from './decorators';
import { BaseApiService, JsonApiQueryData } from './base';
import { ListFilter, WebhookEvent, UrlVars } from '@parashift/shared/models';
import { WebhookEventType } from '@parashift/shared/types';
import { Endpoint } from '../env.service';


@Injectable({
  providedIn: 'root'
})
@ServiceDecorator({
  model: () => WebhookEvent,
  endpointUrl: WebhookEventType
})
export class WebhookEventService extends BaseApiService<WebhookEvent> {
  className = WebhookEventService;

  constructor() {
    super();
    this.baseUrl = Endpoint.webhooks;
    this.apiVersion = this.environment.endpoints.version
  }

  getEventsByWebhook(webhookId?: string, listFilter?: ListFilter, tenant_id?: number): Observable<JsonApiQueryData<WebhookEvent>> {
    const urlVars: UrlVars = {
      before_endpoint_url: `webhooks/${webhookId}`
    };
    this.setProperties(tenant_id, urlVars);
    const httpParams = this.queryParamsService.getParams(listFilter, false, true);
    return this.all({ params: httpParams, metadata: true }).pipe(
      map((result) => new JsonApiQueryData(result.data, { meta: result.meta }))
    );
  }
}
